import { PrivacyNoticeBody } from './PrivacyNoticeBody';
import { usePrivacyNotice } from './usePrivacyNotice';
import { ErrorNotice } from '../ui/ErrorNotice';

/**
 * Die Datenschutzhinweise als eigene Seite.
 *
 * Sie hat eine Adresse, und das ist der Punkt: Der Hinweis muss ohne
 * Buchungsvorgang erreichbar sein — zum Nachlesen, zum Verlinken in einer
 * Betriebsvereinbarung und für die Frage, was eigentlich gespeichert wird,
 * wenn man gerade *nicht* dabei ist, ein Fahrzeug zu buchen.
 */
export function PrivacyNoticePage() {
  const { data, isPending, isError, error } = usePrivacyNotice();

  return (
    <div className="mx-auto max-w-3xl">
      <h2 className="text-xl font-semibold tracking-tight">Datenschutzhinweise</h2>
      <p className="mt-1 text-sm text-slate-500">
        Was bei einer Fahrzeugbuchung gespeichert wird — und warum.
      </p>

      <div className="mt-6 rounded-lg border border-slate-200 bg-white p-6">
        {isPending && <p className="text-sm text-slate-500">Wird geladen …</p>}
        {isError && <ErrorNotice error={error} />}
        {data && <PrivacyNoticeBody notice={data} />}
      </div>
    </div>
  );
}
